/** The sources a shortcut chip panel can offer — its `ChipSource.key` values. */
export type ChipSourceKey = 'recent' | 'competitors' | 'trial' | 'suggested';

/**
 * Where a pick made without the tree came from, for `entity shortcut added`:
 * a chip above the tree, or the company info tooltip's parent / competitor
 * control.
 */
export type ShortcutSource =
  | 'recent'
  | 'competitors'
  | 'trial_plan'
  | 'suggested'
  | 'tooltip_parent'
  | 'tooltip_competitor';

export type TooltipAddSource = Extract<
  ShortcutSource,
  'tooltip_parent' | 'tooltip_competitor'
>;

export const SHORTCUT_SOURCE_BY_CHIP: Record<ChipSourceKey, ShortcutSource> = {
  recent: 'recent',
  competitors: 'competitors',
  trial: 'trial_plan',
  suggested: 'suggested',
};
